// @flow
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PageList from 'components/page/PageList';
import type { DispatchProps, StateProps } from 'components/page/PageList';

import type { DispatchType, StateType } from 'types/Actions';

import { fetchPageList } from 'actions/pageActions';
import { fetchAlbums } from 'actions/albumActions';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      albums: state.albumState.albums,
      albums_filtres: state.pageListState.albums_filtres,
      albums_saisons: state.pageListState.albums_saisons,
      albumsStatus: state.albumState.albumsStatus,
      articles: state.newsletterCategoryState.articles,
      banniere: state.settingsState.banniere,
      description: state.pageListState.description,
      excerpt: state.pageListState.excerpt,
      featured_media: state.pageListState.featured_media,
      label: state.pageListState.label,
      liste_cards: state.cardState.liste_cards,
      liste_enfants: state.pageListState.liste_enfants,
      meta_description: state.pageListState.meta_description,
      meta_title: state.pageListState.meta_title,
      news: state.pageListState.news,
      organization: state.settingsState.title,
      placeholder: state.settingsState.placeholder,
      redirection: state.pageListState.redirection,
      rencontresLive: state.rencontreLiveState.rencontres ? Object.keys(state.rencontreLiveState.rencontres).length : 0,
      sidebar: state.pageListState.sidebar_content,
      status: state.pageListState.status,
      template: state.pageListState.template,
      title: state.pageListState.title,
      ville: state.settingsState.ville
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
      fetchAlbums: () => dispatch(fetchAlbums())
    })
  )(PageList)
);
